import { __assign, __rest } from "tslib";
import * as React from 'react';
import Tab from '../Tab';
import { Tooltip } from '../../Tooltip';
var IconTab = React.forwardRef(function (props, ref) {
    var ariaLabel = props.ariaLabel, label = props.label, tooltipPlacement = props.tooltipPlacement, other = __rest(props, ["ariaLabel", "label", "tooltipPlacement"]);
    if (typeof label !== 'string' && !ariaLabel) {
        throw new Error('ariaLabel must be defined for non-string labels');
    }
    return (React.createElement(Tooltip, { title: label, placement: tooltipPlacement || 'bottom' },
        React.createElement(Tab, __assign({}, other, { ref: ref, "aria-label": typeof label === 'string' ? label : ariaLabel }))));
});
export default IconTab;
//# sourceMappingURL=IconTab.js.map